import React, { useState, useEffect, useRef } from "react";
import { createPortal } from 'react-dom';
import classes from "./uploadModal.module.scss";
import { Spinner } from "elements";
import { successToast, errorToast } from "utils/toast";
import { UploadImage } from "scenes/DecisionMatrix";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as CloseIcon } from "./close.svg";
import { UpdateOption } from "redux/DecisionMatrix/UpdateOptions/action";

const UploadModal = ({ option, setIsUpload, decisionId, setOption }) => {
  const [imageX, setImage] = useState({
    image: "",
    size: "",
    type: "image/jpeg",
  });

  const [imgForAdding, setImgForAdding] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isClose, setIsClose] = useState(false);
  // Add a local copy of the option to prevent the modal from closing after deletion
  const [localOption, setLocalOption] = useState(option);

  const dispatch = useDispatch();

  const { loading: imgLoader ,data } = useSelector(
    (state) => state.updateOptionsReducer
  );


  let { image, size, type } = imageX;

  const isJpgOrPng = type === "image/jpeg" || type === "image/png" || type === "image/webp";

  const uploadImage = async (body) => {
     if (body === null || body === undefined) return;

    const payload = typeof body === "string" ? { image: body } : body;
    if (!option?.id || !decisionId) {
      console.warn("uploadImage: missing option.id or decisionId");
      return;
    }
    setLoading(true);

    try {
        const res = await dispatch(
          UpdateOption({
            id: option.id,
            body: payload,
          })
        );

      if (res && res.status === 200) {
        // Success from API: close modal and show success toast
        if (payload && Object.prototype.hasOwnProperty.call(payload, "image")) {
          if (payload.image === null) {
            successToast("Image deleted successfully");
          } else {
            successToast("Image uploaded successfully");
          }
        } else {
          successToast("Option updated successfully");
        }
        setIsUpload(false);
      }
    } catch (err) {
      // Prefer to show the API error message, but fallback to generic
      const message = err?.response?.data?.error || "Failed to update option";
      errorToast(message);
      console.error("UpdateOption failed:", err);
    } finally {
      setLoading(false);
    }
  };

  // Update localOption when option changes
  useEffect(() => {
    setLocalOption(option);
  }, [option]);

  return createPortal(
    <div className={classes.bg}>
      <div className={classes.wrapper}>
        <div className={classes.header}>
          <span>Upload Picture</span>
          <button
            type="button"
            onClick={() => {
              // When closing the modal, update the Redux state if the image was deleted
              if (localOption.image === null && option.image !== null) {
                  uploadImage({image:null})
                }
              setIsUpload(false);
            }}
            className={classes.close}
            title="Close"
          >
            <CloseIcon />
          </button>
        </div>

        <div className={classes.body}>
          {imgLoader && <div className={classes.loader}>
            <Spinner size={32} />
            </div>
          }

          <span className={classes.warning}>
            {size >= 2 && (
              <span className={classes.centred}>
                <div>Image must smaller than 2MB!</div>
                <div>Select another image!</div>
              </span>
            )}
            {!isJpgOrPng && (
              <span>
                <div>You can only upload JPG/PNG/WEBP file!</div>
              </span>
            )}
          </span>
          {localOption.image ? (
            <img src={localOption.image} alt="" />
          ) : (
            <UploadImage
              setImgForAdding={setImgForAdding}
              imgForAdding={imgForAdding}
              setImage={setImage}
              loading={loading}
              setLoading={setLoading}
              option={localOption}
            />
          )}
        </div>

        <div className={classes.footer}>
          {imgForAdding || localOption.image ? (
            <button
              className={classes.delete}
              disabled={loading || imgLoader}
              onClick={() => {
                // Update local state immediately to show upload interface
                setLocalOption({...localOption, image: null});
                setImage({ ...imageX, image: null });
                setLoading(true);
                setTimeout(() => {
                  setLoading(false);
                }, 500);
                setImgForAdding(null);
              }}
            >
              DELETE
            </button>
          ) : (
            ""
          )}
          {image && imgForAdding && size < 2 && isJpgOrPng && (
            <button
              className={classes.upload}
              disabled={loading || imgLoader}
              onClick={() => {
                // Upload the new image
                uploadImage(image instanceof FormData ? image : { image });
                setIsClose(true);

              }}
            >
              UPLOAD
            </button>
          )}

          {(!image || (size >= 2 && !localOption.image)) && (
            <button
              className={classes.upload}
              onClick={async() => {
                // When closing the modal, update the Redux state if the image was deleted
                if (localOption.image === null && option.image !== null) {
                  await uploadImage({ image: null })
                }
                setIsUpload(false);
              }}
            >
              Close
            </button>
          )}
        </div>
      </div>
    </div>,
    document.getElementById('portal-root')
  );
};

export { UploadModal };
